import ContractDetail from '@components/common/pv-contracts/ContractDetail';
import ErrorPage from '@components/common/ErrorPage';
import React from 'react';
import {useParams} from 'react-router-dom';

const PVContractDetailPage = () => {
  const {contractId} = useParams();
  const contractIdNum = Number(contractId);

  if (isNaN(contractIdNum)) {
    return <ErrorPage statusCode={404} />;
  }

  return <ContractDetail contractId={contractIdNum} planPage />;
};

export default PVContractDetailPage;
